export * from './new-negocio-dialog.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/new-negocio-dialog/index.ts